(function () {
  'use strict';

  /* @ngdoc object
   * @name vcfinance.cart
   * @description
   *
   */
  angular
    .module('vcfinance.cart', [
      'vcutils',
      'vcutils.printhelper'
    ]);
}());
